import { render } from "./FooterOrderDetails.vue?vue&type=template&id=e1175860"
import script from "./FooterOrderDetails.vue?vue&type=script&lang=js"
export * from "./FooterOrderDetails.vue?vue&type=script&lang=js"

import "./FooterOrderDetails.vue?vue&type=style&index=0&id=e1175860&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__